module.exports = __webpack_public_path__ + "fonts/Pretendard-SemiBold.d5ded8a.woff2";